import React from "react";

const Alert: React.FC<{ children: React.ReactNode; type?: "info" | "error" }> = ({
  children,
  type = "info",
}) => (
  <div
    className={`rounded-lg px-4 py-3 mb-4 ${
      type === "error"
        ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
        : "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
    }`}
  >
    {children}
  </div>
);

export default Alert; 